/* Miel Planet — Atlas · comportements du thème
   Sans dépendance. Chaque bloc s'active seulement si ses éléments existent.
   Règle : aucun prix n'est calculé ici quand Shopify peut le rendre ; le
   panier est redemandé en HTML (API de rendu des sections). Seul le coffret
   affiche une ESTIMATION, présentée comme telle. */
(function () {
  'use strict';

  var MP = window.MP || { routes: { cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update' }, textes: {}, paliers: '' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function argent(centimes) {
    var n = (Number(centimes) || 0) / 100;
    var parties = n.toFixed(2).split('.');
    var ent = parties[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var fmt = MP.format || '{{amount_with_space_separator}} €';
    var val = /no_decimals/.test(fmt) ? ent : ent + ',' + parties[1];
    if (/amount}}/.test(fmt) && !/comma|space|apostrophe|period/.test(fmt)) val = n.toFixed(2);
    return fmt.replace(/{{\s*amount[a-z_]*\s*}}/, val);
  }

  function paliers() {
    return (MP.paliers || '').split('|').filter(Boolean).map(function (p) {
      var x = p.split(':');
      return { qte: +x[0], pct: +x[1], nom: x.slice(2).join(':') };
    }).sort(function (a, b) { return a.qte - b.qte; });
  }

  /* ------------------------------------------------------------ piège du focus */
  function pieger(conteneur, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])', conteneur).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }
  var verrous = 0;
  function verrouiller(oui) {
    verrous = Math.max(0, verrous + (oui ? 1 : -1));
    document.documentElement.style.overflow = verrous ? 'hidden' : '';
  }

  /* ------------------------------------------------------------ barre d'annonces */
  (function () {
    var boite = $('[data-annonce]');
    if (!boite || reduit) return;
    var msgs = $$('.annonce__msg', boite);
    if (msgs.length < 2) return;
    var i = 0, pause = false;
    boite.addEventListener('mouseenter', function () { pause = true; });
    boite.addEventListener('mouseleave', function () { pause = false; });
    setInterval(function () {
      if (pause || window.innerWidth >= 1000) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 4200);
  })();

  /* ------------------------------------------------------------ menus déroulants */
  (function () {
    var items = $$('[data-deroulant]');
    if (!items.length) return;
    var minuteur;
    function fermerTout(sauf) {
      items.forEach(function (it) {
        if (it === sauf) return;
        it.classList.remove('is-open');
        var b = $('button', it); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    function ouvrir(it) {
      fermerTout(it);
      it.classList.add('is-open');
      $('button', it).setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (it) {
      var b = $('button', it);
      b.addEventListener('click', function () { it.classList.contains('is-open') ? fermerTout() : ouvrir(it); });
      it.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { clearTimeout(minuteur); ouvrir(it); } });
      it.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) { minuteur = setTimeout(function () { fermerTout(); }, 180); } });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); } });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerTout(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-deroulant]')) fermerTout(); });
  })();

  /* ------------------------------------------------------------ menu mobile */
  (function () {
    var menu = $('[data-menu]');
    var bouton = $('[data-menu-ouvrir]');
    if (!menu || !bouton) return;
    document.body.appendChild(menu); // hors de l'en-tête collant, sinon il est rogné
    function ouvrir() {
      menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false');
      bouton.setAttribute('aria-expanded', 'true'); verrouiller(true);
      setTimeout(function () { var f = $('.menu__fermer', menu); if (f) f.focus(); }, 60);
    }
    function fermer() {
      if (!menu.classList.contains('is-open')) return;
      menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true');
      bouton.setAttribute('aria-expanded', 'false'); verrouiller(false); bouton.focus();
    }
    bouton.addEventListener('click', ouvrir);
    $$('[data-menu-fermer]', menu).forEach(function (el) { el.addEventListener('click', fermer); });
    menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); pieger($('.menu__panneau', menu), e); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { if (a.getAttribute('href').charAt(0) === '#' || a.pathname === location.pathname) fermer(); }); });
  })();

  /* ------------------------------------------------------------ panier */
  var Panier = (function () {
    var racine = $('[data-tiroir]');
    var surPagePanier = document.body.classList.contains('gabarit-cart');
    var retourFocus = null;
    if (racine) document.body.appendChild(racine);

    function sectionsDemandees() {
      var ids = ['cart-drawer'];
      $$('[data-section-panier]').forEach(function (el) { ids.push(el.getAttribute('data-section-panier')); });
      return ids;
    }

    function appliquer(sections) {
      if (!sections) return;
      if (sections['cart-drawer'] && racine) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var neuf = $('[data-tiroir]', doc);
        if (neuf) {
          var corps = $('.tiroir__corps', racine);
          var defil = corps ? corps.scrollTop : 0;
          $('.tiroir__pan', racine).innerHTML = $('.tiroir__pan', neuf).innerHTML;
          racine.setAttribute('data-compte', neuf.getAttribute('data-compte'));
          var c2 = $('.tiroir__corps', racine); if (c2) c2.scrollTop = defil;
        }
      }
      $$('[data-section-panier]').forEach(function (el) {
        var id = el.getAttribute('data-section-panier');
        if (!sections[id]) return;
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var neuf = $('[data-section-panier]', doc);
        if (neuf) el.innerHTML = neuf.innerHTML;
      });
      compter();
    }

    function compter() {
      var n = racine ? parseInt(racine.getAttribute('data-compte'), 10) || 0 : null;
      if (n === null) return;
      $$('[data-panier-compte]').forEach(function (el) {
        var avant = el.textContent;
        el.textContent = n;
        el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
        if (String(n) !== avant) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
      });
    }

    function ouvrir() {
      if (!racine || surPagePanier) return;
      retourFocus = document.activeElement;
      racine.classList.add('is-open'); racine.setAttribute('aria-hidden', 'false'); verrouiller(true);
      setTimeout(function () { var f = $('.fermer', racine); if (f) f.focus({ preventScroll: true }); }, 80);
    }
    function fermer() {
      if (!racine || !racine.classList.contains('is-open')) return;
      racine.classList.remove('is-open'); racine.setAttribute('aria-hidden', 'true'); verrouiller(false);
      if (retourFocus && retourFocus.focus) retourFocus.focus({ preventScroll: true });
    }
    function occupe(oui) { if (racine) racine.classList.toggle('is-busy', !!oui); }

    function poster(url, corps) {
      occupe(true);
      corps.sections = sectionsDemandees().join(',');
      corps.sections_url = window.location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) })
        .then(function (r) { return r.json().then(function (j) { occupe(false); return { ok: r.ok, j: j }; }); })
        .catch(function () { occupe(false); return { ok: false, j: {} }; });
    }

    function ajouter(items, bouton) {
      if (bouton) { bouton.classList.add('is-loading'); bouton.setAttribute('aria-busy', 'true'); }
      return poster(MP.routes.add + '.js', { items: items }).then(function (r) {
        if (bouton) { bouton.classList.remove('is-loading'); bouton.removeAttribute('aria-busy'); }
        if (!r.ok) {
          alerte(bouton, (r.j && (r.j.description || r.j.message)) || MP.textes.erreur);
          return false;
        }
        appliquer(r.j.sections);
        if (bouton) retour(bouton);
        document.dispatchEvent(new CustomEvent('mp:ajout', { detail: { items: items } }));
        if (MP.tiroirAuto !== false) ouvrir();
        return true;
      });
    }

    function retour(bouton) {
      bouton.classList.add('is-done');
      var lib = $('span', bouton);
      var ancien = lib ? lib.textContent : null;
      if (lib && MP.textes.ajoute) lib.textContent = MP.textes.ajoute;
      setTimeout(function () { bouton.classList.remove('is-done'); if (lib && ancien) lib.textContent = ancien; }, 1800);
    }

    function alerte(pres, message) {
      var zone = pres && pres.closest('form') ? $('[data-erreur]', pres.closest('form')) : null;
      if (zone) { zone.textContent = message; zone.hidden = false; return; }
      window.alert(message);
    }

    function changer(cle, quantite) {
      return poster(MP.routes.change + '.js', { id: cle, quantity: quantite }).then(function (r) { if (r.ok) appliquer(r.j.sections); });
    }

    // formulaires « ajouter » (cartes, fiche, suggestions)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajout]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
      var props = {};
      fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) item.properties = props;
      ajouter([item], form.querySelector('[type="submit"]'));
    });

    // lots (trio découverte, trio du guide) : plusieurs pots d'un coup
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ajout-lot]');
      if (!b) return;
      e.preventDefault();
      var ids = b.getAttribute('data-ajout-lot').split(',').filter(Boolean);
      ajouter(ids.map(function (id) { return { id: id, quantity: 1 }; }), b);
    });

    // ouverture / fermeture
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-panier-ouvrir]');
      if (a && racine && !surPagePanier && !(e.metaKey || e.ctrlKey || e.shiftKey)) { e.preventDefault(); ouvrir(); return; }
      if (e.target.closest('[data-tiroir-fermer]')) { e.preventDefault(); fermer(); }
    });
    if (racine) racine.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); pieger($('.tiroir__pan', racine), e); });

    // lignes : quantité, retrait (tiroir et page panier)
    var attente;
    document.addEventListener('click', function (e) {
      var ligne = e.target.closest('[data-ligne]');
      if (!ligne) return;
      var cle = ligne.getAttribute('data-ligne');
      var champ = $('[data-ligne-qte]', ligne);
      var q = parseInt(champ.value, 10) || 0;
      if (e.target.closest('[data-ligne-plus]')) { champ.value = q + 1; }
      else if (e.target.closest('[data-ligne-moins]')) { champ.value = Math.max(0, q - 1); }
      else if (e.target.closest('[data-ligne-suppr]')) { champ.value = 0; ligne.style.opacity = '.4'; changer(cle, 0); return; }
      else return;
      clearTimeout(attente);
      attente = setTimeout(function () { changer(cle, parseInt(champ.value, 10) || 0); }, 350);
    });
    document.addEventListener('change', function (e) {
      var champ = e.target.closest('[data-ligne-qte]');
      if (champ) { var l = champ.closest('[data-ligne]'); changer(l.getAttribute('data-ligne'), Math.max(0, parseInt(champ.value, 10) || 0)); }
    });

    // message cadeau : enregistré sans attendre la commande
    var attenteNote;
    document.addEventListener('input', function (e) {
      if (!e.target.matches('[data-note]')) return;
      var v = e.target.value;
      clearTimeout(attenteNote);
      attenteNote = setTimeout(function () {
        fetch(MP.routes.update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
      }, 500);
    });

    // bouton « Commander » : Shopify redirige vers le paiement
    return { ajouter: ajouter, ouvrir: ouvrir, fermer: fermer };
  })();
  window.MPPanier = Panier;

  /* ------------------------------------------------------------ fiche produit */
  (function () {
    $$('[data-qte]').forEach(function (bloc) {
      var champ = $('input', bloc);
      bloc.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-pas]');
        if (!b) return;
        var v = (parseInt(champ.value, 10) || 1) + parseInt(b.getAttribute('data-pas'), 10);
        champ.value = Math.max(1, Math.min(99, v));
        champ.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // barre d'achat collante : visible quand le bouton principal est sorti de l'écran
    var barre = $('[data-barre-achat]');
    var cible = $('[data-achat-principal]');
    if (barre && cible && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        var e = entrees[0];
        barre.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(cible);
      var bb = $('button', barre);
      if (bb) bb.addEventListener('click', function () {
        var form = cible.closest('form');
        if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit();
      });
    }

    // vidéos d'ambiance (héros, fiche produit) : muettes, en boucle, sans commande.
    // Elles apparaissent en fondu dès qu'elles jouent, et repartent si on les arrête.
    $$('.plein__media video, [data-ambiance] video').forEach(function (v) {
      var jouer = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      var montrer = function () { v.classList.add('is-lue'); };
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.controls = false;
      if (v.readyState > 2 && !v.paused) montrer();
      v.addEventListener('playing', montrer);
      v.addEventListener('pause', function () { if (!document.hidden) jouer(); });
      setTimeout(montrer, 4000);
      jouer();
      document.addEventListener('visibilitychange', function () { if (!document.hidden && v.paused) jouer(); });
    });

    // galerie : les miniatures changent la grande photo
    $$('[data-galerie-produit]').forEach(function (g) {
      var vues = $$('[data-vue]', g), vignettes = $$('[data-vers]', g);
      vignettes.forEach(function (v) {
        v.addEventListener('click', function () {
          var i = v.getAttribute('data-vers');
          vues.forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-vue') === i); });
          vignettes.forEach(function (x) { var on = x === v; x.classList.toggle('is-on', on); if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
        });
      });
    });

    // galerie mobile : points
    var piste = $('[data-galerie]');
    var points = $$('[data-galerie-points] i');
    if (piste && points.length) {
      piste.addEventListener('scroll', function () {
        var i = Math.round(piste.scrollLeft / (piste.firstElementChild.getBoundingClientRect().width + 8));
        points.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }
  })();

  /* ------------------------------------------------------------ onglets */
  $$('[data-onglets]').forEach(function (bloc) {
    var tabs = $$('[role="tab"]', bloc);
    function choisir(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.classList.toggle('is-on', on);
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { choisir(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return;
        e.preventDefault();
        var n = tabs[(i + k + tabs.length) % tabs.length];
        n.focus(); choisir(n);
      });
    });
  });

  /* ------------------------------------------------------------ atlas */
  $$('[data-pin-lien]').forEach(function (chip) {
    var pin = $('[data-pin="' + chip.getAttribute('data-pin-lien') + '"]');
    if (!pin) return;
    chip.addEventListener('mouseenter', function () { pin.classList.add('is-on'); });
    chip.addEventListener('mouseleave', function () { pin.classList.remove('is-on'); });
    chip.addEventListener('focus', function () { pin.classList.add('is-on'); });
    chip.addEventListener('blur', function () { pin.classList.remove('is-on'); });
  });

  /* ------------------------------------------------------------ guide « Trouver mon miel » */
  $$('[data-guide]').forEach(function (app) {
    var form = $('[data-guide-form]', app);
    var questions = $$('[data-question]', form);
    var sortie = $('[data-guide-resultat]', app);
    var modele = $('[data-guide-modele]', app);
    var retourBtn = $('[data-guide-retour]', app);
    var etapes = $$('[data-guide-etapes] li', app.closest('section'));
    var produits = [];
    try { produits = JSON.parse($('[data-guide-produits]', app).textContent); } catch (e) { produits = []; }
    var courant = 0;

    function montrer(i) {
      courant = i;
      questions.forEach(function (q, k) { q.hidden = k !== i; });
      retourBtn.hidden = i === 0;
      etapes.forEach(function (e, k) { e.classList.toggle('is-done', k < i); });
      var premier = $('input', questions[i]);
      if (premier && i > 0) questions[i].querySelector('legend').scrollIntoView({ block: 'nearest', behavior: reduit ? 'auto' : 'smooth' });
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      setTimeout(function () {
        if (courant < questions.length - 1) montrer(courant + 1);
        else resultat();
      }, 220);
    });
    retourBtn.addEventListener('click', function () { if (courant > 0) montrer(courant - 1); });

    function reponses() {
      return questions.map(function (q) { return $('input:checked', q); }).filter(Boolean).map(function (r) {
        return {
          i: parseInt(r.getAttribute('data-intensite'), 10) || 0,
          tags: (r.getAttribute('data-tags') || '').split(',').filter(Boolean),
          regions: (r.getAttribute('data-regions') || '').split(',').filter(Boolean),
          raison: r.getAttribute('data-raison') || ''
        };
      });
    }

    function noter(p, rep, rang) {
      var s = 0;
      var tags = (p.tags || '').split(',');
      rep.forEach(function (r) {
        if (r.i > 0) s -= Math.abs((p.i || 3) - r.i) * 2.2;
        r.tags.forEach(function (t) { if (tags.indexOf(t) > -1) s += 2; });
        if (r.regions.length) s += r.regions.indexOf(p.r) > -1 ? 3 : -1.5;
      });
      return s - rang * 0.001; // à égalité : l'ordre de la collection (vos meilleures ventes d'abord)
    }

    function resultat() {
      var rep = reponses();
      var notes = produits.map(function (p, k) { return { p: p, s: noter(p, rep, k) }; }).sort(function (a, b) { return b.s - a.s; });
      if (!notes.length) return;
      var top = notes[0].p;
      // deux autres, d'un autre pays si possible, et d'un caractère différent
      var alts = [];
      for (var k = 1; k < notes.length && alts.length < 2; k++) {
        var c = notes[k].p;
        if (c.o !== top.o && alts.every(function (a) { return a.o !== c.o; })) alts.push(c);
      }
      for (k = 1; k < notes.length && alts.length < 2; k++) if (alts.indexOf(notes[k].p) < 0 && notes[k].p !== top) alts.push(notes[k].p);

      var frag = modele.content.cloneNode(true);
      var g = function (n) { return $('[data-g="' + n + '"]', frag); };
      var raisons = rep.map(function (r) { return r.raison; }).filter(Boolean);
      g('titre').textContent = top.n;
      g('raison').textContent = raisons.length ? 'Choisi pour vous : ' + raisons.join(' · ') + '.' : 'Un très bon point de départ pour découvrir la boutique.';
      g('img').src = top.img; g('img').alt = top.t;
      g('origine').textContent = top.o;
      g('nom').textContent = top.t;
      g('notes').textContent = (top.notes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 3).join(' · ');
      g('prix').textContent = top.prix;
      g('lien').href = top.u;
      g('ajout').setAttribute('data-ajout-lot', top.v);
      var zone = g('alts');
      alts.forEach(function (a) {
        var l = document.createElement('a');
        l.className = 'alt'; l.href = a.u;
        l.innerHTML = '<img alt="" width="144" height="144" loading="lazy"><div><b></b><span></span></div>';
        l.querySelector('img').src = a.img;
        l.querySelector('b').textContent = a.n;
        l.querySelector('span').textContent = a.o + ' · ' + a.prix;
        zone.appendChild(l);
      });
      var p1 = paliers()[0];
      var trio = [top].concat(alts);
      if (trio.length === 3) {
        var total = trio.reduce(function (s, x) { return s + x.c; }, 0);
        var txt = 'Les trois ensemble : ' + argent(total);
        if (p1 && p1.qte <= 3) txt += ', et <b>−' + p1.pct + ' %</b> au panier';
        g('trio-txt').innerHTML = txt + '.';
        g('trio-btn').setAttribute('data-ajout-lot', trio.map(function (x) { return x.v; }).join(','));
      } else g('trio').remove();

      sortie.innerHTML = '';
      sortie.appendChild(frag);
      form.hidden = true; sortie.hidden = false;
      etapes.forEach(function (e) { e.classList.add('is-done'); });
      $('[data-guide-recommencer]', sortie).addEventListener('click', function () {
        form.reset(); sortie.hidden = true; form.hidden = false; montrer(0);
      });
      sortie.querySelector('h3').setAttribute('tabindex', '-1');
      sortie.querySelector('h3').focus({ preventScroll: true });
      app.scrollIntoView({ block: 'nearest', behavior: reduit ? 'auto' : 'smooth' });
    }
  });

  /* ------------------------------------------------------------ filtres de collection */
  $$('[data-filtres]').forEach(function (barre) {
    var grille = $(barre.getAttribute('data-filtres'));
    if (!grille) return;
    var cartes = $$('[data-carte]', grille);
    var compte = $('[data-compte-visible]', barre);
    var vide = $('[data-vide]', grille.parentNode);
    var tuile = $('[data-tuile]', grille);
    var etat = { pays: [], region: [], gout: [], texture: [], tri: 'ordre' };
    var params = new URLSearchParams(location.search);
    ['pays', 'region', 'gout', 'texture'].forEach(function (k) { var v = params.get(k); if (v) etat[k] = v.split(','); });
    if (params.get('tri')) etat.tri = params.get('tri');

    var gouts = { doux: function (c) { return +c.dataset.intensite <= 2; }, aromatique: function (c) { return +c.dataset.intensite === 3; }, corse: function (c) { return +c.dataset.intensite >= 4; } };
    function tags(c) { return ' ' + (c.dataset.tags || '') + ' '; }
    function garde(c) {
      if (etat.pays.length && etat.pays.indexOf(c.dataset.pays) < 0) return false;
      if (etat.region.length && etat.region.indexOf(c.dataset.region) < 0) return false;
      if (etat.gout.length && !etat.gout.some(function (g) { return gouts[g] ? gouts[g](c) : tags(c).indexOf(' ' + g + ' ') > -1; })) return false;
      if (etat.texture.length && !etat.texture.some(function (t) { return tags(c).indexOf(' ' + t + ' ') > -1; })) return false;
      return true;
    }
    function trier(a, b) {
      switch (etat.tri) {
        case 'prix-asc': return a.dataset.prix - b.dataset.prix;
        case 'prix-desc': return b.dataset.prix - a.dataset.prix;
        case 'doux': return a.dataset.intensite - b.dataset.intensite || a.dataset.ordre - b.dataset.ordre;
        case 'corse': return b.dataset.intensite - a.dataset.intensite || a.dataset.ordre - b.dataset.ordre;
        case 'nom': return a.dataset.nom.localeCompare(b.dataset.nom, 'fr');
        default: return a.dataset.ordre - b.dataset.ordre;
      }
    }
    function rendre(pousserUrl) {
      var n = 0;
      cartes.slice().sort(trier).forEach(function (c) {
        var ok = garde(c);
        c.classList.toggle('is-masque', !ok);
        if (ok) n++;
        grille.appendChild(c);
      });
      if (tuile) { tuile.hidden = n < 6; var ref = grille.querySelectorAll('[data-carte]:not(.is-masque)')[5]; if (ref) ref.after(tuile); }
      if (compte) compte.textContent = compte.getAttribute('data-modele').replace('[n]', n);
      if (vide) vide.hidden = n > 0;
      $$('[data-filtre]', barre).forEach(function (b) {
        var k = b.getAttribute('data-filtre'), v = b.getAttribute('data-valeur');
        var on = v === '' ? !etat.pays.length && !etat.region.length && !etat.gout.length && !etat.texture.length : etat[k].indexOf(v) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-deroulant-filtre]', document).forEach(function (d) {
        var k = d.getAttribute('data-deroulant-filtre');
        var lib = $('[data-nb]', d.closest('.deroulant') || d);
        $$('input', d).forEach(function (i) { i.checked = etat[k].indexOf(i.value) > -1; });
        if (lib) lib.textContent = etat[k].length ? ' (' + etat[k].length + ')' : '';
      });
      if (pousserUrl) {
        var p = new URLSearchParams();
        ['pays', 'region', 'gout', 'texture'].forEach(function (k) { if (etat[k].length) p.set(k, etat[k].join(',')); });
        if (etat.tri !== 'ordre') p.set('tri', etat.tri);
        history.replaceState(null, '', location.pathname + (p.toString() ? '?' + p : ''));
      }
    }
    barre.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filtre]');
      if (!b) return;
      var k = b.getAttribute('data-filtre'), v = b.getAttribute('data-valeur');
      if (v === '') { etat.pays = []; etat.region = []; etat.gout = []; etat.texture = []; }
      else { var i = etat[k].indexOf(v); if (i > -1) etat[k].splice(i, 1); else etat[k].push(v); }
      rendre(true);
    });
    document.addEventListener('change', function (e) {
      var d = e.target.closest('[data-deroulant-filtre]');
      if (d) { var k = d.getAttribute('data-deroulant-filtre'); etat[k] = $$('input:checked', d).map(function (i) { return i.value; }); rendre(true); }
      if (e.target.matches('[data-tri]')) { etat.tri = e.target.value; rendre(true); }
    });
    var tri = $('[data-tri]', barre); if (tri) tri.value = etat.tri;
    rendre(false);
  });

  // listes déroulantes de filtres (pays)
  $$('.deroulant').forEach(function (d) {
    var b = $('.deroulant__btn', d), pan = $('.deroulant__pan', d);
    if (!b || !pan) return;
    document.body.appendChild(pan); // hors de la barre qui défile horizontalement
    pan.setAttribute('data-deroulant-filtre', pan.getAttribute('data-deroulant-filtre'));
    function placer() {
      var r = b.getBoundingClientRect();
      pan.style.top = (r.bottom + 8) + 'px';
      pan.style.left = Math.max(12, Math.min(r.left, window.innerWidth - pan.offsetWidth - 12)) + 'px';
    }
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var ouvert = !pan.hidden;
      pan.hidden = ouvert; b.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      if (!ouvert) placer();
    });
    window.addEventListener('scroll', function () { if (!pan.hidden) placer(); }, { passive: true });
    document.addEventListener('click', function (e) { if (!pan.contains(e.target) && e.target !== b) { pan.hidden = true; b.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pan.hidden = true; b.setAttribute('aria-expanded', 'false'); } });
  });

  /* ------------------------------------------------------------ composer un coffret */
  $$('[data-coffret]').forEach(function (app) {
    var formats = $$('input[name="format"]', app);
    var pots = $$('[data-pot]', app);
    var cases = $('[data-cases]', app);
    var compte = $('[data-coffret-compte]', app);
    var bouton = $('[data-coffret-ajout]', app);
    var brut = $('[data-coffret-brut]', app), remiseEl = $('[data-coffret-remise]', app), totalEl = $('[data-coffret-total]', app);
    var cadeau = $('[data-coffret-cadeau]', app);
    var choix = {}; // id → quantité

    function taille() { var f = formats.filter(function (x) { return x.checked; })[0]; return f ? parseInt(f.value, 10) : 3; }
    function total() { return Object.keys(choix).reduce(function (s, k) { return s + choix[k]; }, 0); }

    function rendre() {
      var n = taille(), t = total();
      cases.style.setProperty('--n', Math.min(n, 6));
      cases.innerHTML = '';
      var imgs = [];
      Object.keys(choix).forEach(function (id) { var el = $('[data-pot="' + id + '"]', app); for (var i = 0; i < choix[id]; i++) imgs.push(el.getAttribute('data-img')); });
      for (var i = 0; i < n; i++) {
        var c = document.createElement('div'); c.className = 'case';
        if (imgs[i]) { var im = document.createElement('img'); im.src = imgs[i]; im.alt = ''; c.appendChild(im); } else c.textContent = '+';
        cases.appendChild(c);
      }
      pots.forEach(function (el) {
        var q = choix[el.getAttribute('data-pot')] || 0;
        el.classList.toggle('is-choisi', q > 0);
        $('[data-q]', el).textContent = q;
        $('[data-moins]', el).disabled = q === 0;
        $('[data-plus]', el).disabled = t >= n;
      });
      var reste = n - t;
      compte.textContent = reste > 0 ? compte.getAttribute('data-reste').replace('[n]', reste).replace('[s]', reste > 1 ? 's' : '') : compte.getAttribute('data-plein');
      var somme = 0;
      Object.keys(choix).forEach(function (id) { somme += choix[id] * parseInt($('[data-pot="' + id + '"]', app).getAttribute('data-prix'), 10); });
      var pal = paliers().filter(function (p) { return t >= p.qte; }).pop();
      var rem = pal ? Math.round(somme * pal.pct / 100) : 0;
      brut.textContent = argent(somme);
      remiseEl.textContent = rem ? '−' + argent(rem) + ' (' + pal.nom + ')' : '—';
      remiseEl.parentNode.hidden = !rem;
      totalEl.textContent = argent(somme - rem);
      bouton.disabled = reste !== 0;
    }

    app.addEventListener('click', function (e) {
      var el = e.target.closest('[data-pot]');
      if (el) {
        var id = el.getAttribute('data-pot');
        if (e.target.closest('[data-plus]') && total() < taille()) choix[id] = (choix[id] || 0) + 1;
        if (e.target.closest('[data-moins]') && choix[id]) { choix[id]--; if (!choix[id]) delete choix[id]; }
        rendre();
        return;
      }
      if (e.target.closest('[data-coffret-auto]')) {
        // un miel par pays et par caractère, jusqu'à remplir la boîte
        choix = {};
        var n = taille(), vusPays = {}, vusI = {};
        var dispo = pots.filter(function (p) { return p.getAttribute('data-dispo') === 'true'; });
        dispo.slice().sort(function () { return Math.random() - .5; }).forEach(function (p) {
          if (total() >= n) return;
          var pa = p.getAttribute('data-pays'), it = p.getAttribute('data-intensite');
          if (vusPays[pa] || (vusI[it] && Object.keys(vusI).length < 5)) return;
          vusPays[pa] = vusI[it] = true; choix[p.getAttribute('data-pot')] = 1;
        });
        dispo.forEach(function (p) { if (total() < n && !choix[p.getAttribute('data-pot')]) choix[p.getAttribute('data-pot')] = 1; });
        rendre();
      }
      if (e.target.closest('[data-coffret-vider]')) { choix = {}; rendre(); }
    });
    // filtres de la liste (région, goût)
    $$('[data-pot-filtre]', app).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-pot-filtre]', app).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var f = b.getAttribute('data-pot-filtre').split(':');
        pots.forEach(function (p) {
          var i = +p.getAttribute('data-intensite'), ok = true;
          if (f[0] === 'region') ok = p.getAttribute('data-region') === f[1];
          if (f[0] === 'gout') ok = f[1] === 'doux' ? i <= 2 : f[1] === 'aromatique' ? i === 3 : i >= 4;
          p.classList.toggle('is-masque', !ok);
        });
      });
    });
    formats.forEach(function (f) { f.addEventListener('change', function () {
      var n = taille();
      while (total() > n) { var k = Object.keys(choix).pop(); choix[k]--; if (!choix[k]) delete choix[k]; }
      rendre();
    }); });
    bouton.addEventListener('click', function () {
      var items = Object.keys(choix).map(function (id) {
        var it = { id: id, quantity: choix[id] };
        if (cadeau && cadeau.checked) it.properties = { 'Coffret cadeau': 'Oui' };
        return it;
      });
      window.MPPanier.ajouter(items, bouton).then(function (ok) { if (ok) { choix = {}; rendre(); } });
    });
    rendre();
  });

  /* ------------------------------------------------------------ préférences cookies */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cookies]')) return;
    e.preventDefault();
    if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    else if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences) window.Shopify.customerPrivacy.showPreferences();
  });

  /* ------------------------------------------------------------ apparition au défilement */
  (function () {
    var els = $$('.apparait');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduit) { els.forEach(function (e) { e.classList.add('is-vu'); }); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-vu'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // filet de sécurité : un onglet en arrière-plan ne déclenche pas l'observateur
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-vu'); }); }, 2500);
  })();

  /* ------------------------------------------------------------ customizer */
  document.addEventListener('shopify:section:load', function () { window.location.reload(); });
})();
